// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"34":"chunk-4-my-collection-index-js","167":"chunk-3-movie-details-index-js","246":"chunk-0-all-movies-index-js","457":"chunk-2-error404-index-js","677":"chunk-5-top-rated-movies-index-js","900":"chunk-1-create-movie-index-js"}[chunkId] + ".bundle.js";
};